import { Box, Divider, Flex, Heading, Text } from '@podiumhq/design-system';

import { useSelectPlanCheckoutContext } from 'contexts/SelectPlanCheckoutContextProvider';
import PodiumLogoIcon from '../../PodiumLogo/PodiumLogoIcon';

const SelectedPlanSummary = ({ term = 'month', ...boxProps }) => {
  const { selectedPlan = {} } = useSelectPlanCheckoutContext() || {};

  const { displayName: planName, monthlyPrice: price } = selectedPlan || {};
  const lineHeight = '150%';
  const boldTextStyles = {
    fontSize: 'lg',
    fontWeight: 'medium',
    lineHeight,
  };

  return (
    <Box
      backgroundColor="silver.light"
      borderRadius="12px"
      boxSizing="border-box"
      padding="24px"
      width="100%"
      {...boxProps}
    >
      <Flex>
        <PodiumLogoIcon height="48px" mr="16px" width="48px" />
        <Box>
          <Heading color="black.base" mb="2px" {...boldTextStyles}>
            {planName}
          </Heading>

          <Text fontSize="md" fontWeight="normal" lineHeight="150%">
            ${price} USD / {term} + taxes
          </Text>
        </Box>
      </Flex>

      <Divider margin="24px 0" />

      <Flex justify="space-between">
        <Text {...boldTextStyles}>Total</Text>
        <Text {...boldTextStyles}>${price}</Text>
      </Flex>
    </Box>
  );
};

export default SelectedPlanSummary;
